import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spin } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import dayjs from "dayjs";
import message from "../json/message.json";
import { CONSTANT } from "../../../../config/Constant";
import SVGIcon from "../../../../utils/SVGIcon";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../store/app";
import {
  fetchAddPortabilityNumber,
  fetchCheckAction,
  fetchInquireNumberAction,
  fetchPublish,
  getProviderListCode,
} from "../../../../store/SendMessageSlice";
import { useNavigate } from "react-router-dom";
import ConfiremStartModal from "./ConfiremStartModal";
import { getInternalCodeList } from "../../../../store/NumberManagementSlice";

const SubmitForm: React.FC<any> = ({
  getList,
  getInquireList,
  messageAction,
  setMessageAction,
  getAddPortNumberList,
  getPublishList,
}) => {
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const [networkTypeAction, setNetworkTypeAction] = useState<string>("");
  const [numberTypeAction, setNumberTypeAction] = useState<string>("S");
  const [loading, setLoading] = useState<boolean>(false);
  const [providerListCode, setProviderListCode] = useState<any>();
  const [openConfirem, setOpenConfirem] = useState<any>(false);
  const [internalProviderListCode, setInternalProviderListCode] = useState<any>(
    []
  );

  const updateProviderListCode = () => {
    dispatch(getProviderListCode())
      .then((res: any) => {
        const listOfProviders = res?.data
          .filter((item) => item?.id)
          .reduce((acc, current) => {
            const x = acc.find((item) => item.id === current.id);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
        listOfProviders && setProviderListCode(listOfProviders);
      })
      .catch((error: any) => {
        setProviderListCode([]);
      });
  };

  const updateInternalProviderListCode = () => {
    // let updateProvider = {id:"", lable:""}
    const payload = {
      current: 0,
      page_size: 0,
      // user_id: '661e722d74bca72daa7d1a3b',
    };
    dispatch(getInternalCodeList(payload))
      .then((res: any) => {
        const response =
          res?.data?.length > 0
            ? res?.data?.map((item: any) => ({
                id: `${item?.code}`,
                lable: `${item?.code} - ${item?.code_name}`,
              }))
            : []; //res?.data.map((item: any) => console.log('item?.code', item))

        setInternalProviderListCode(response);
      })
      .catch((error: any) => {
        setInternalProviderListCode([]);
      });
  };

  const CheckAction = (payload: any) => {
    setLoading(true);
    dispatch(fetchCheckAction(payload))
      .then((res: any) => {
        form.resetFields();
        setLoading(false);
        getList();
        setOpenConfirem(false);
        setNetworkTypeAction("");
        setNumberTypeAction("S");
      })
      .catch((error: any) => {
        setLoading(false);
        // getList();
      });
  };

  const InquireNumber = (payload: any) => {
    dispatch(fetchInquireNumberAction(payload))
      .then((res: any) => {
        form.resetFields();
        setLoading(false);
        getInquireList();
      })
      .catch((error: any) => {
        setLoading(false);
        // getInquireList();
      });
  };

  const Publish = (payload: any) => {
    dispatch(fetchPublish(payload))
      .then((res: any) => {
        form.resetFields();
        setLoading(false);
        getPublishList();
      })
      .catch((error: any) => {
        setLoading(false);
        // getInquireList();
      });
  };

  const AddPortabilityNumber = (payload: any) => {
    dispatch(fetchAddPortabilityNumber(payload))
      .then((res: any) => {
        form.resetFields();
        setLoading(false);
        getAddPortNumberList();
      })
      .catch((error: any) => {
        setLoading(false);
        // getAddPortNumberList();
      });
  };

  const closeConfiremModal = () => {
    setOpenConfirem(false);
    setLoading(false);
  };

  const handleSubmit = async (data) => {
    setLoading(true);

    if (data?.message_action === "Start") {
      setLoading(false);
      data.message_action = "Check";
      const payload = {
        ...data,
        number_type: data?.number_type2 || data?.number_type1,
      };

      delete payload?.number_type2;
      delete payload?.number_type1;
      setOpenConfirem(payload);

      // CheckAction(payload);
      // form.resetFields();
      // setNetworkTypeAction("");
    } else if (data?.message_action === "Inquire_number") {
      const inquireyPayload = {
        ...data,
        number: data?.number,
        to_provider: data?.to_provider,
        email: data?.email,
      };
      // InquireNumberAction(inquireyPayload);
      InquireNumber(inquireyPayload);
      form.resetFields();
    } else if (data?.message_action === "Publish") {
      const publishPayload = {
        ...data,
        number: data?.number,
        to_provider: data?.to_provider,
        email: data?.email,
      };
      // InquireNumberAction(inquireyPayload);
      Publish(publishPayload);
      form.resetFields();
    } else if (data?.message_action === "Add_portability_number") {
      const AddPortabilityNumberPayload = {
        ...data,
        phone_number: data?.phone_number,
        provider: data?.provider,
        email: data?.email,
      };
      delete AddPortabilityNumberPayload?.message_action;
      AddPortabilityNumber(AddPortabilityNumberPayload);
      form.resetFields();
    }
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  // const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  //   // Can not select days before today and today
  //   return current && current > dayjs().endOf('day');
  // };
  useEffect(() => {
    form.setFieldValue(
      "current_time",
      dayjs(new Date()).format(CONSTANT.DATE_TIME_FORMAT)
    );
    form.setFieldValue(
      "transfer_time",
      dayjs(new Date()).add(15, "m").format(CONSTANT.DATE_TIME_FORMAT)
    );
  }, [form]);

  useEffect(() => {
    form.resetFields();
    form.setFieldValue("message_action", messageAction);
  }, [form, messageAction]);

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
        initialValues={{ range_size: 10, number_type1: "I", number_type2: "S" }}
      >
        <Row gutter={[20, 0]} align={"bottom"}>
          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Select
              label="Message Action"
              name={"message_action"}
              allowClear
              disabled
              showSearch
              initialValue={messageAction}
              options={{
                list: message && message,
                valueKey: "value",
                textKey: "label",
              }}
              onChange={(val: string) => {
                setMessageAction(val);
                console.log("val", val);
                // navigate(`/action?action=${val}`);
                if (val === "Check") {
                  navigate(`/action?action=Start`);
                } else {
                  navigate(`/action?action=${val}`);
                }
              }}
              // required
              // rules={[validations.required.select('Message')]}
            />
          </Col>

          {messageAction === "Start" ? (
            <>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Provider"
                  name={"to_provider"}
                  allowClear
                  showSearch
                  placeholder="Select Provider Code"
                  tooltip="Select on from provided network provider list"
                  onFocus={() =>
                    providerListCode?.length > 0
                      ? null
                      : updateProviderListCode()
                  }
                  notFoundContent={
                    providerListCode?.length > 0 ? null : <Spin />
                  }
                  options={{
                    list: providerListCode && providerListCode,
                    valueKey: "id",
                    textKey: "provider_code",
                  }}
                  required
                  rules={[validations.required.select("Provider Code")]}
                />
              </Col>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Network Type"
                  name={"network_type"}
                  required
                  rules={[validations.required.select("Network Type")]}
                  placeholder="Select Network Type"
                  tooltip={
                    <>
                      For cellular number, the value must be <strong>M</strong>.{" "}
                      <br />
                      For a fixed number (landline) the value must be{" "}
                      <strong>F</strong>.
                    </>
                  }
                  options={{
                    list: CONSTANT.NETWORK_TYPE,
                    valueKey: "id",
                    textKey: "value",
                  }}
                  onChange={(val: string) => {
                    setNetworkTypeAction(val);
                  }}
                />
              </Col>

              {networkTypeAction === "M" ? (
                <Col xs={24} md={12} lg={6} xxl={6}>
                  <InputBox.Text
                    disabled
                    label="Number Type"
                    name={"number_type1"}
                    required
                    rules={[validations.required.select("Number Type")]}
                    placeholder="Select Number Type"
                    value={"I"}
                    tooltip={
                      <>
                        For cellular the value must be <strong>I</strong>.
                      </>
                    }
                  />
                </Col>
              ) : (
                networkTypeAction === "F" && (
                  <Col xs={24} md={12} lg={6} xxl={6}>
                    <InputBox.Select
                      label="Number Type"
                      name="number_type2"
                      required
                      rules={[validations.required.select("Number Type")]}
                      placeholder="Select Number Type"
                      tooltip={
                        <>
                          Single number must be <strong>S</strong>. <br />
                          Range of numbers must be <strong>R</strong>.
                        </>
                      }
                      options={{
                        list: CONSTANT.NUMBER_TYPE,
                        valueKey: "id",
                        textKey: "value",
                      }}
                      onChange={(val: string) => {
                        setNumberTypeAction(val);
                      }}
                    />
                  </Col>
                )
              )}

              {networkTypeAction === "M" || numberTypeAction === "S" ? (
                <Col xs={24} md={12} lg={6} xxl={6}>
                  <InputBox.Text
                    label="Number"
                    name={"number"}
                    tooltip="A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)"
                    required
                    rules={[
                      validations.required.text("Number"),
                      // validations.pattern.numericWithSecial,
                      validations.pattern.whitespace,
                      validations.pattern.multiplenumber,
                    ]}
                  />
                </Col>
              ) : (
                <>
                  <Col xs={24} md={12} lg={6} xxl={6}>
                    <InputBox.Text
                      label="From Number"
                      name={"from_number"}
                      tooltip="A beginning of a ranged fixed (landline) number.
                      Must be in a domestic form (e.g. 0312350)."
                      required
                      rules={[
                        validations.required.text("From Number"),
                        validations.pattern.numericWithSecial,
                        validations.pattern.whitespace,
                      ]}
                    />
                  </Col>
                  <Col xs={24} md={12} lg={6} xxl={6}>
                    <InputBox.Text
                      label="To Number"
                      name={"to_number"}
                      tooltip="The end of a ranged fixed (landline) number.
                      Must be in a domestic form (e.g. 0312359)."
                      required
                      rules={[
                        validations.required.text("To Number"),
                        validations.pattern.numericWithSecial,
                        validations.pattern.whitespace,
                      ]}
                    />
                  </Col>
                  <Col xs={24} md={12} lg={6} xxl={6}>
                    <InputBox.Text
                      label="Range Size"
                      name={"range_size"}
                      tooltip="range size"
                      required
                      rules={[
                        validations.required.text("range_size"),
                        // validations.pattern.numericWithSecial,
                        validations.pattern.whitespace,
                        validations.pattern.numeric,
                      ]}
                    />
                  </Col>
                </>
              )}

              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  label="Identification Value"
                  name={"identification_value"}
                  tooltip="Place 0 here or 123456782 (as valid I.D. number that does not exist)."
                  required
                  rules={[
                    validations.required.text("Identification Value"),
                    validations.pattern.numeric,
                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  label="Identification Value 2nd"
                  name={"identification_value2nd"}
                  tooltip="Place 0 here or 123456782 (as valid I.D. number that does not exist)."
                  rules={[
                    validations.required.text("Identification Value 2nd"),
                    validations.pattern.numeric,
                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  label="Identification Value 3rd"
                  name={"identification_value3rd"}
                  tooltip="Place 0 here or 123456782 (as valid I.D. number that does not exist)."
                  rules={[
                    validations.required.text("Identification Value 3rd"),
                    validations.pattern.numeric,
                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Internal Provider Code"
                  name={"provider_code"}
                  allowClear
                  showSearch
                  placeholder="Select Internal Provider Code"
                  tooltip="Select on from provided network provider list"
                  // onFocus={() => console.log('providerListCode', providerListCode?.length)}
                  onFocus={() =>
                    internalProviderListCode?.length > 0
                      ? null
                      : updateInternalProviderListCode()
                  }
                  notFoundContent={
                    internalProviderListCode?.length > 0 ? null : <Spin />
                  }
                  options={{
                    list: internalProviderListCode ?? [],
                    valueKey: "id",
                    textKey: "lable",
                  }}
                  required
                  rules={[validations.required.select("Provider Code")]}
                />
              </Col>
              {/* <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  name="email"
                  label="Email"
                  tooltip="Please enter up to 5 valid email addresses, separated by commas."
                  rules={[
                    validations.required.text("Provider Email"),
                    validations.pattern.multiEmail("Provider Email"),
                    validations.pattern.whitespace,
                  ]}
                />
              </Col> */}
            </>
          ) : messageAction === "Inquire_number" ? (
            <>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Provider Code"
                  name={"to_provider"}
                  allowClear
                  showSearch
                  placeholder="Select Provider Code"
                  tooltip="Select on from provided network provider list"
                  onFocus={() =>
                    providerListCode?.length > 0
                      ? null
                      : updateProviderListCode()
                  }
                  notFoundContent={
                    providerListCode?.length > 0 ? null : <Spin />
                  }
                  options={{
                    list: providerListCode && providerListCode,
                    valueKey: "id",
                    textKey: "provider_code",
                  }}
                  required
                  rules={[validations.required.select("Provider Code")]}
                />
              </Col>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  label="Number"
                  name={"number"}
                  tooltip="A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)"
                  required
                  rules={[
                    validations.required.text("Number"),
                    // validations.pattern.numericWithSecial
                    validations.pattern.multiplenumber,

                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
              {/* <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  name="email"
                  label="Email"
                  tooltip="Please enter up to 5 valid email addresses, separated by commas."
                  rules={[
                    validations.required.text("Provider Email"),
                    validations.pattern.multiEmail("Provider Email"),
                    validations.pattern.whitespace,
                  ]}
                />
              </Col> */}
            </>
          ) : messageAction === "Add_portability_number" ? (
            <>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Provider Code"
                  name={"provider"}
                  allowClear
                  showSearch
                  placeholder="Select Provider Code"
                  tooltip="Select on from provided network provider list"
                  onFocus={() =>
                    providerListCode?.length > 0
                      ? null
                      : updateProviderListCode()
                  }
                  notFoundContent={
                    providerListCode?.length > 0 ? null : <Spin />
                  }
                  options={{
                    list: providerListCode && providerListCode,
                    valueKey: "id",
                    textKey: "provider_code",
                  }}
                  required
                  rules={[validations.required.select("Provider Code")]}
                />
              </Col>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  label="Phone Number"
                  name={"phone_number"}
                  tooltip="A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)"
                  required
                  rules={[
                    validations.required.text("Number"),
                    // validations.pattern.numericWithSecial,
                    validations.pattern.whitespace,
                    validations.pattern.multiplenumber,
                  ]}
                />
              </Col>
              {/* <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  name="email"
                  label="Email"
                  tooltip="Please enter up to 5 valid email addresses, separated by commas."
                  rules={[
                    validations.required.text("Provider Email"),
                    validations.pattern.multiEmail("Provider Email"),
                    validations.pattern.whitespace,
                  ]}
                />
              </Col> */}
            </>
          ) : messageAction === "Publish" ? (
            <>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Provider"
                  name={"to_provider"}
                  allowClear
                  showSearch
                  mode="tags"
                  maxTagCount={1}
                  placeholder="Select Provider Code"
                  tooltip="Select on from provided network provider list"
                  onFocus={() =>
                    providerListCode?.length > 0
                      ? null
                      : updateProviderListCode()
                  }
                  notFoundContent={
                    providerListCode?.length > 0 ? null : <Spin />
                  }
                  options={{
                    list: providerListCode && providerListCode,
                    valueKey: "id",
                    textKey: "provider_code",
                  }}
                  required
                  rules={[validations.required.select("Provider Code")]}
                />
              </Col>
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Network Type"
                  name={"network_type"}
                  required
                  rules={[validations.required.select("Network Type")]}
                  placeholder="Select Network Type"
                  tooltip={
                    <>
                      For cellular number, the value must be <strong>M</strong>.{" "}
                      <br />
                      For a fixed number (landline) the value must be{" "}
                      <strong>F</strong>.
                    </>
                  }
                  options={{
                    list: CONSTANT.NETWORK_TYPE,
                    valueKey: "id",
                    textKey: "value",
                  }}
                  onChange={(val: string) => {
                    setNetworkTypeAction(val);
                  }}
                />
              </Col>

              {networkTypeAction === "M" ? (
                <Col xs={24} md={12} lg={6} xxl={6}>
                  <InputBox.Text
                    disabled
                    label="Number Type"
                    name={"number_type"}
                    required
                    rules={[validations.required.select("Number Type")]}
                    placeholder="Select Number Type"
                    value={"I"}
                    initialValue={"I"}
                    tooltip={
                      <>
                        For cellular the value must be <strong>I</strong>.
                      </>
                    }
                  />
                </Col>
              ) : (
                networkTypeAction === "F" && (
                  <Col xs={24} md={12} lg={6} xxl={6}>
                    <InputBox.Select
                      label="Number Type"
                      name="number_type"
                      required
                      rules={[validations.required.select("Number Type")]}
                      placeholder="Select Number Type"
                      initialValue={"S"}
                      tooltip={
                        <>
                          Single number must be <strong>S</strong>. <br />
                          Range of numbers must be <strong>R</strong>.
                        </>
                      }
                      options={{
                        list: CONSTANT.NUMBER_TYPE,
                        valueKey: "id",
                        textKey: "value",
                      }}
                      onChange={(val: string) => {
                        setNumberTypeAction(val);
                      }}
                    />
                  </Col>
                )
              )}

              {networkTypeAction === "M" || numberTypeAction === "S" ? (
                <Col xs={24} md={12} lg={6} xxl={6}>
                  <InputBox.Text
                    label="Number"
                    name={"number"}
                    tooltip="A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)"
                    required
                    rules={[
                      validations.required.text("Number"),
                      validations.pattern.numericWithSecial,
                      validations.pattern.singlenumber,
                      validations.pattern.whitespace,
                      // validations.pattern.multiplenumber,
                    ]}
                  />
                </Col>
              ) : (
                <>
                  <Col xs={24} md={12} lg={6} xxl={6}>
                    <InputBox.Text
                      label="From Number"
                      name={"from_number"}
                      tooltip="A beginning of a ranged fixed (landline) number.
                      Must be in a domestic form (e.g. 0312350)."
                      required
                      rules={[
                        validations.required.text("From Number"),
                        validations.pattern.numericWithSecial,
                        validations.pattern.whitespace,
                      ]}
                    />
                  </Col>
                  <Col xs={24} md={12} lg={6} xxl={6}>
                    <InputBox.Text
                      label="To Number"
                      name={"to_number"}
                      tooltip="The end of a ranged fixed (landline) number.
                      Must be in a domestic form (e.g. 0312359)."
                      required
                      rules={[
                        validations.required.text("To Number"),
                        validations.pattern.numericWithSecial,
                        validations.pattern.whitespace,
                      ]}
                    />
                  </Col>
                </>
              )}
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Text
                  label="Request_id"
                  name={"request_id"}
                  // tooltip="Place 0 here or 123456782 (as valid I.D. number that does not exist)."
                  // required
                  rules={[
                    // validations.required.text("Request_id"),
                    // validations.pattern.numeric,
                    validations.pattern.whitespace,
                  ]}
                />
              </Col>
            </>
          ) : null}

          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Text
              name="email"
              label="Email"
              tooltip="Please enter up to 5 valid email addresses, separated by commas."
              rules={[
                validations.required.text("Provider Email"),
                validations.pattern.multiEmail("Provider Email"),
                validations.pattern.whitespace,
              ]}
            />
          </Col>
        </Row>
        <Row gutter={[20, 20]} className="mt-20">
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button type="primary" htmlType="submit" loading={loading}>
              {!loading && <SVGIcon icon="send" color="#fff" width={55} />} Send
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button
              type="default"
              // htmlType="reset"
              onClick={() => {
                form.resetFields();
                getAddPortNumberList();
                getList();
                getInquireList();
                setNetworkTypeAction("");
                setNumberTypeAction("S");
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>

      {openConfirem && (
        <ConfiremStartModal
          visible={openConfirem}
          close={closeConfiremModal}
          CheckAction={CheckAction}
          loading={loading}
        />
      )}
    </>
  );
};

export default SubmitForm;
